// Skeleton — shimmer placeholder used while data is loading. Drives the
// `tcs-shimmer` keyframe defined in tailwind.config.js. Use these the way
// the mockups do: a stack of varied-width rows that approximates the shape
// of the content that will replace it.
//
// `width` and `height` accept any CSS value; default height matches a body
// text line. For block-level skeletons (chart areas, image placeholders),
// pass `height="64px"` or similar.

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  /** Render as `inline-block` (default) or `block`. */
  block?: boolean;
}

export function Skeleton({
  width,
  height = 12,
  className,
  block,
}: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={`${block ? 'block' : 'inline-block'} animate-tcs-shimmer rounded-md ${className ?? ''}`}
      style={{
        width,
        height,
        backgroundImage:
          'linear-gradient(90deg, #F5F5F4 0px, #EAE9E7 40px, #F5F5F4 80px)',
        backgroundSize: '200px 100%',
      }}
    />
  );
}
